import React from 'react';
import styles from './Dropdown.module.css';

export default function Dropdown({ children, className = '', ...rest }) {
  return (
    <div className={`${styles.dropdown} ${className}`} {...rest}>
      {children}
    </div>
  );
}

Dropdown.Toggle = function DropdownToggle({ children, className = '', ...rest }) {
  return (
    <button className={`${styles.toggle} ${className}`} {...rest}>
      {children}
    </button>
  );
};

Dropdown.Menu = function DropdownMenu({ children, className = '', align = 'start', ...rest }) {
  return (
    <div className={`${styles.menu} ${styles[`align-${align}`]} ${className}`} {...rest}>
      {children}
    </div>
  );
};

Dropdown.Item = function DropdownItem({ children, active = false, onClick, className = '', ...rest }) {
  return (
    <button
      className={`${styles.item} ${active ? styles.active : ''} ${className}`}
      onClick={onClick}
      {...rest}
    >
      {children}
    </button>
  );
};
